// removed by extract-text-webpack-plugin
module.exports = {"container":"_2P0dWBm"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SidePrimaryNavigation/index.css
// module id = ./template/components/Navigation/SidePrimaryNavigation/index.css
// module chunks = client.sitechrome